/**
 * Malaysian ringgit.
 */
export var MYR = {
  code: 'MYR',
  base: 10,
  exponent: 2
};